import React from 'react';
import _ from 'lodash';
import {Link} from "react-router-dom";

export const Pagination = props => {

    const {itemCount,pageSize,onHandlePage, currentPage} = props;
    const pageCount  = Math.ceil(itemCount/pageSize);
    if (pageCount===1) return null;
    const pages = _.range(1,pageCount+1);

    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center py-3">
                {pages.map(page=> (
                    <li className={page===currentPage ? 'page-item active':'page-item'} key={page}>
                        <Link to='#' className="page-link" onClick={()=>onHandlePage(page)}>{page}</Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
}